import {
  ContentTypeRender,
  Link,
  useLocation,
  Wrapper,
} from "nystem-components";
import app from "nystem";

const StyleTabs = ({ model, path }) => {
  const tabs = model.tabs || [];
  const { pathname, search } = useLocation();
  const saveId = model.saveId || "tab";
  const selected = new URLSearchParams(search).get(saveId);
  const selectedTab = tabs.find(({ id }) => id === selected) || tabs[0];

  if (!selectedTab) return null;

  return (
    <Wrapper className={model.className}>
      <Wrapper
        renderAs="div"
        role="tablist"
        className={
          model.tabListClassName || [
            "mb-4",
            "flex",
            "gap-1",
            "border-b",
            "border-stone-300",
            "overflow-x-auto",
          ]
        }
      >
        {tabs.map((tab, index) => {
          const query = new URLSearchParams(search);
          if (index) query.set(saveId, tab.id);
          else query.delete(saveId);

          return (
            <Link
              key={tab.id}
              to={tab.url || `${pathname}?${query.toString()}`}
              role="tab"
              aria-selected={selectedTab.id === tab.id}
              className={[
                model.tabClassName || [
                  "whitespace-nowrap",
                  "border-b-2",
                  "px-4",
                  "py-3",
                  "text-sm",
                  "font-semibold",
                  "transition-colors",
                ],
                selectedTab.id === tab.id
                  ? model.activeTabClassName || [
                      "border-emerald-700",
                      "bg-emerald-50",
                      "text-emerald-900",
                    ]
                  : model.inactiveTabClassName || [
                      "border-transparent",
                      "text-stone-500",
                      "hover:border-stone-300",
                      "hover:text-stone-800",
                    ],
              ]}
            >
              {app.t(tab.text)}
            </Link>
          );
        })}
      </Wrapper>
      <Wrapper className={model.contentClassName}>
        <ContentTypeRender path={path} items={selectedTab.item || []} />
      </Wrapper>
    </Wrapper>
  );
};

export default StyleTabs;
